//@ts-nocheck
import React, { Component } from 'react'
import InteractableListItem from './InteractableListItem'

class InteractableList extends Component {
  _itemClickHandler = data => {
    this.props.onClick(data)
  }

  renderItem = item => {
    const { renderItem } = this.props

    if (typeof renderItem === 'function') {
      return renderItem(item)
    }

    return item
  }

  getListItems = () => {
    const { items } = this.props

    return items.map((item, index) => {
      return (
        <InteractableListItem
          key={index}
          style={{ cursor: 'pointer' }}
          onClick={data => {
            this._itemClickHandler(data)
          }}
          onMouseOut={data => {
            this.props.onMouseOut(data)
          }}
          onMouseOver={data => {
            this.props.onMouseOver(data)
          }}
          data={item}
        >
          {this.renderItem(item)}
        </InteractableListItem>
      )
    })
  }

  render() {
    const items = this.getListItems()

    return <>{items || 'No results found.'}</>
  }
}

InteractableList.defaultProps = {
  background: {
    base: 'transparent',
    active: 'transparent',
    hover: '#eee',
  },
  color: {
    base: '#333333',
    active: '#333333',
    hover: 'rgba(255,0,0,0.8)',
  },
  items: [],
  onMouseOut: () => {},
  onMouseOver: () => {},
  onClick: () => {},
}

export default InteractableList
